export default __webpack_public_path__ + "static/media/tour-8.4aa33cbc.png";